/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_ApproveInputs */

const en_booking_approve = /** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve Booking`)
};

const es_booking_approve = /** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobar Reserva`)
};

const fr_booking_approve = /** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuver la réservation`)
};

const de_booking_approve = /** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchung genehmigen`)
};

const id_booking_approve = /** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setujui Pemesanan`)
};

/** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */
const ja_booking_approve = en_booking_approve;

/** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */
const zh_booking_approve = en_booking_approve;

/** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */
const ar_booking_approve = en_booking_approve;

/** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */
const it_booking_approve = en_booking_approve;

/** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */
const ru_booking_approve = en_booking_approve;

/** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */
const pt_booking_approve = en_booking_approve;

/** @type {(inputs: Booking_ApproveInputs) => LocalizedString} */
const ko_booking_approve = en_booking_approve;

/**
* | output |
* | --- |
* | "Approve Booking" |
*
* @param {Booking_ApproveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_approve = /** @type {((inputs?: Booking_ApproveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_ApproveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_approve(inputs)
	if (locale === "es") return es_booking_approve(inputs)
	if (locale === "fr") return fr_booking_approve(inputs)
	if (locale === "de") return de_booking_approve(inputs)
	if (locale === "ja") return ja_booking_approve(inputs)
	if (locale === "zh") return zh_booking_approve(inputs)
	if (locale === "ar") return ar_booking_approve(inputs)
	if (locale === "id") return id_booking_approve(inputs)
	if (locale === "it") return it_booking_approve(inputs)
	if (locale === "ru") return ru_booking_approve(inputs)
	if (locale === "pt") return pt_booking_approve(inputs)
	return ko_booking_approve(inputs)
});